import React, { Fragment } from 'react';
import classnames from 'classnames';
import Tooltip from '@homeaway/react-tooltip';
import { SVGIcon } from '@homeaway/react-svg';
import { MORE__16 } from '@homeaway/svg-defs';

var renderDataTable = function renderDataTable(input) {
  var tableBody = input.map(function (inp, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: "event-doc-" + index + "-" + inp.name.replace(/\W/g, '-')
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, inp.name)), /*#__PURE__*/React.createElement("td", null, inp.value));
  });
  return /*#__PURE__*/React.createElement("table", {
    className: "table table-condensed EventDocs__PopoverTable"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "PropDocs__th"
  }, 'Key'), /*#__PURE__*/React.createElement("th", {
    className: "PropDocs__th"
  }, 'Value'))), /*#__PURE__*/React.createElement("tbody", null, tableBody));
};

var renderContent = function renderContent(input, renderAsDataTable) {
  if (renderAsDataTable === void 0) {
    renderAsDataTable = false;
  }

  var containerClass = classnames({
    PropDocs__Popover: !renderAsDataTable
  });
  var output = input;

  if (input.map && renderAsDataTable) {
    output = renderDataTable(input);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, output);
};

var renderPropValue = function renderPropValue(output, renderAsDataTable, parentNode) {
  if (renderAsDataTable === void 0) {
    renderAsDataTable = false;
  }

  // This regex checks to disallow {} and [] but allow { something : foo} or ["foo"] (basically -- nonEmpty Object and Arrays)
  // This is method is used for formatting both `type` and `default` columns, but this RegEx will only affect `default` data
  var nonEmptyDataRegex = /[{|\[][^}|\]]/;
  var isDataType = false;
  var stringOutput = '';
  var stringPreview;

  if (typeof output === 'string') {
    stringPreview = output.substr(0, output.indexOf(' '));
    isDataType = nonEmptyDataRegex.test(stringPreview);
  }

  if (isDataType) {
    stringPreview = stringOutput.substring(0, 15);
  }

  if (renderAsDataTable) {
    return /*#__PURE__*/React.createElement(Fragment, null, '{', /*#__PURE__*/React.createElement(Tooltip, {
      parentNode: parentNode,
      content: renderContent(output, true),
      trigger: "hover click focus",
      tooltipType: "popover"
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: "text-link",
      inlineFlex: true,
      markup: MORE__16
    })), '}');
  }

  if (stringPreview === 'shape' || stringPreview === 'arrayOf' || isDataType) {
    return /*#__PURE__*/React.createElement(Fragment, null, stringPreview, ' ', /*#__PURE__*/React.createElement(Tooltip, {
      parentNode: parentNode,
      content: renderContent(output, false),
      trigger: "hover click focus",
      tooltipType: "popover"
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: "text-link",
      inlineFlex: true,
      markup: MORE__16
    })));
  }

  return output;
};

export default renderPropValue;
export { renderPropValue, renderContent, renderDataTable };
//# sourceMappingURL=renderPropEventValues.js.map